import { Schema, arrayOf } from 'normalizr';
import moment from 'moment';

export const page = new Schema('pages');
export const content = new Schema('contents');

export const deployment = new Schema('deployments', {
  idAttribute: 'version',
  assignEntity: (output, key, value, input) => {
    // Update date to moment
    if (key === 'deployedAt') {
      output.deployedAt = moment(value).locale('fr');
    } else {
      output[key] = value;
    }
  },
});

page.define({
  contents: arrayOf(content),
});

export const pages = arrayOf(page);
export const deployments = arrayOf(deployment);



// WEBPACK FOOTER //
// ./src/modules/catalog/api/schema.js